import Vue from 'vue'
import Router from 'vue-router'
import Loding from '../components/loding.vue'
import Home from '../components/home.vue'
import About from '../components/about.vue'
import Skill from '../components/skill.vue'
import Portfolio from '../components/portfolio.vue'
import Contact from '../components/contact.vue'

Vue.use(Router)

// 라우터 설정 시작
var router = new Router({
  mode: 'history', // 해쉬값 제거
  routes: [
    // 페이지별 링크 주소
    {path: '/', component: Loding },
    {path: '/home', component: Home },
    {path: '/about', component: About },
    {path: '/skill', component: Skill },
    {path: '/portfolio', component: Portfolio },
    {path: '/contact', component: Contact },
  ]
});

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js